'use client'
// Types
import type { IAvailableIcons } from './Icon'
import type { IColor } from './types'
// Components
import { Box, Typography, Icon } from '@/CommonComponents'
import ClicableItem from '@/components/hoc/ClickableItem'
// Services
import { download } from '@/services/store'

export interface IExternalURLProps {
  url?: string | null
  label: string
  icon: IAvailableIcons
  store?: { path?: string | null }
  iconColor?: IColor
}

export default function ExternalURL({ url, label, icon, store, iconColor = 'secondary' }: IExternalURLProps) {
  if (!url && !store?.path) return null
  const handleClick = async () => {
    if (store?.path) {
      const storeURL = await download(store.path)
      window.open(storeURL, '_blank')
      return
    }
    if (url) window.open(url, '_blank')
  }
  return (
    <ClicableItem onClick={handleClick}>
      <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1, alignItems: 'center' }}>
        <Icon icon={icon} color={iconColor} />
        <Typography variant="body2">{label}</Typography>
      </Box>
    </ClicableItem>
  )
}
